var scope_0 = require('/home/sergios/src/theaisummer.com_v2.0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1b89a232cffba381a30855b0f893d688.js').default;
var scope_1 = require('/home/sergios/src/theaisummer.com_v2.0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/27291e9f4b4cedc19653c2e1e6418021.js').default;
var scope_2 = require('/home/sergios/src/theaisummer.com_v2.0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a56db47a7d4f3ae627a0f4607f308026.js').default;
var scope_3 = require('/home/sergios/src/theaisummer.com_v2.0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    